import { createContext, useContext, useLayoutEffect, useState, type ReactNode } from 'react';

export type PlatformMainMode = 'default' | 'fill';

function unsetPlatformMainMode(_mode: PlatformMainMode): void {
  return undefined;
}

const PlatformMainModeContext =
  createContext<(mode: PlatformMainMode) => void>(unsetPlatformMainMode);

/** Lets a page fill the viewport under the platform header. The setter is a no-op without the chrome. */
export function usePlatformMainMode(mode: PlatformMainMode) {
  const setMode = useContext(PlatformMainModeContext);
  useLayoutEffect(() => {
    setMode(mode);
    return () => setMode('default');
  }, [mode, setMode]);
}

export function PlatformMainModeProvider({
  children,
}: {
  children: (mode: PlatformMainMode) => ReactNode;
}) {
  const [mode, setMode] = useState<PlatformMainMode>('default');
  return (
    <PlatformMainModeContext.Provider value={setMode}>
      {children(mode)}
    </PlatformMainModeContext.Provider>
  );
}
